module.exports = __webpack_public_path__ + "img/icon-man-computer-heart.25bff6e.svg";